import React, { Component } from "react";
import Header from "../components/Header";
import Tabs from '../components/Tabs';
import Tab from '../components/Tab';
import PropTypes from 'prop-types';
import config from '../config/config';
import Video from '../components/Video';
import CardGrid from '../components/CardGrid';
import { isEmpty } from '../helpers';

import { AppContext } from "../context/AppContext";
import localize from "../hoc/localize";
//import { Fade } from "@progress/kendo-react-animation";

//!DBTRANS! @m0004@ Home !DEVNOTE! Option label
//!DBTRANS! @m0404@ Is there a way to manually change SOM-suggested orders? !DEVNOTE! FAQ question
//!DBTRANS! @m0405@ SOM is an intelligent, self-evaluating system that uses advanced algorithms to generate suggested orders for precisely the right parts, in the perfect quantity, for you. The key word here is%space% !DEVNOTE! 
//!DBTRANS! @m0406@ How does SOM account for my busy and slow seasons? !DEVNOTE! FAQ question
//!DBTRANS! @m0407@ SOM automatically detects part seasonality, based on historical sales, demand patterns, and current sales trend. It extrapolates that information into a sales forecast for a configurable period that makes sense for your business. SOM then adjusts inventory levels accordingly and helps your business ease in and out of high and low seasons without you suffering from under/overstock issues. !DEVNOTE! 
//!DBTRANS! @m0408@ How are superseded and obsolete parts handled in SOM? !DEVNOTE! FAQ question
//!DBTRANS! @m0409@ SOM will not suggest obsolete parts in an order, nor old parts in the superseded parts chain, as long as the OEM provides regular parts updates. !DEVNOTE! 
//!DBTRANS! @m0410@ How does SOM work with part package quantities? !DEVNOTE! FAQ question
//!DBTRANS! @m0411@ SOM respects OEM part ordering requirements for packaged parts or parts with defined MOQ. SOM-suggested orders automatically reflect OEM requirements. For packaged parts, the quantity value represents the number of packages to order; otherwise, it indicates the number of individual parts to order. !DEVNOTE! 
//!DBTRANS! @m0412@ How can I use SOM-suggested orders in my DMS? !DEVNOTE! FAQ question
//!DBTRANS! @m0413@ In Super SOM you can export current suggested order into an Excel or CSV file format. !DEVNOTE! 
//!DBTRANS! @m0414@ The Excel file format includes a part number, description, order quantity, package part indicator, package quantity, cost, and total cost. This format is useful for those who prefer to enter suggested orders into the DMS manually. !DEVNOTE! 
//!DBTRANS! @m0415@ The CSV file includes only a part number and order quantity ( !DEVNOTE! 
//!DBTRANS! @m0416@ Is there a way to make SOM ignore exceptional sales? !DEVNOTE! FAQ question
//!DBTRANS! @m0417@ An exceptional sale is one that is considered "above and beyond" regular sales activity. Super SOM algorithms will ignore them, but only if they are marked as exceptional in your DMS. !DEVNOTE! 
//!DBTRANS! @m0418@ Can I permanently exclude a part from SOM suggested orders? !DEVNOTE! FAQ question
//!DBTRANS! @m0419@ Yes. You can flag the part as “Non-Stock” in your DMS, or flag it (Never Order checkbox) in SOM part exceptions settings. !DEVNOTE! 
//!DBTRANS! @m0420@ How often should I use SOM suggested orders? !DEVNOTE! FAQ question
//!DBTRANS! @m0421@ SOM is capable of generating suggested orders daily if desired. Optimal frequency, however, depends on your business and your typical full-cycle lead-time for order submission through shipment, receiving, and stocking of parts. For example, if your usual lead-time is two weeks, we suggest a weekly or bi-weekly order, to ensure availability of stock and to stay on top of parts with an uptrend in demand. !DEVNOTE! 
//!DBTRANS! @m0422@ Videos !DEVNOTE! Text label
//!DBTRANS! @m0423@ Need support? Contact us at !DEVNOTE! Text label
//!DBTRANS! @m0424@ and we'll be happy to help. !DEVNOTE! Text label
//!DBTRANS! @m0425@ Support !DEVNOTE! Page title
//!DBTRANS! @m0546@ suggested !DEVNOTE! 
//!DBTRANS! @m0547@ %space%— you can change the order before submitting it. But we strongly recommend ordering as suggested. SOM’s ever-increasing precision will solidify your trust with every order.  You can change the part order quantity in the current SOM-suggested order by altering the value displayed in the Order Qty column. !DEVNOTE! 
//!DBTRANS! @m0548@ in packages if applicable !DEVNOTE! 
//!DBTRANS! @m0549@ ). This format is designed to import your suggested order directly into a purchase order within your DMS ( !DEVNOTE! 
//!DBTRANS! @m0550@ ). !DEVNOTE! 
//!DBTRANS! @m0551@ if the CSV file import option is supported on the purchase order screen of your DMS !DEVNOTE! 

class FAQEntry extends Component {
    static propTypes = {
        question: PropTypes.string,
        answer: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    }
    state = {
        isOpened: false
    }
    handleClick = (e) => {

        const isOpened = this.state.isOpened;
        this.setState({ 'isOpened': !isOpened })
    }
    render() {
        return (
            <React.Fragment>
                <section className="faq-entry">
                    {!isEmpty(this.props.question) && <div onClick={this.handleClick} className={`question ${this.state.isOpened ? 'expanded' : ''}`}>{this.props.question}</div>}
                    {!isEmpty(this.props.answer) && <div className={`answer`}>{this.props.answer}</div>}
                </section>
            </React.Fragment>
        );
    }
}

class FAQ extends Component {
    render() {
        return (
            <React.Fragment>
                <h2 className="top-margin-10">FAQ</h2>
                <section className="faq">

                    <FAQEntry question={this.props.returnLocalizedString("m0404")} answer={(
                        <p>
                            {this.props.returnLocalizedString("m0405")}<strong><em>{this.props.returnLocalizedString("m0546")}</em></strong>{this.props.returnLocalizedString("m0547")}
                        </p>
                    )} />
                    <FAQEntry question={this.props.returnLocalizedString("m0406")} answer={this.props.returnLocalizedString("m0407")} />
                    <FAQEntry question={this.props.returnLocalizedString("m0408")} answer={this.props.returnLocalizedString("m0409")} />
                    <FAQEntry question={this.props.returnLocalizedString("m0410")} answer={this.props.returnLocalizedString("m0411")} />
                    <FAQEntry question={this.props.returnLocalizedString("m0412")} answer={(<React.Fragment>
                        <p>{this.props.returnLocalizedString("m0413")}</p>

                        <p>{this.props.returnLocalizedString("m0414")}</p>

                        <p>{this.props.returnLocalizedString("m0415")}<strong><em>{this.props.returnLocalizedString("m0548")}</em></strong>{this.props.returnLocalizedString("m0549")}<strong><em>{this.props.returnLocalizedString("m0551")}</em></strong>{this.props.returnLocalizedString("m0550")}</p>
                    </React.Fragment>
                    )} />
                    <FAQEntry question={this.props.returnLocalizedString("m0416")} answer={this.props.returnLocalizedString("m0417")} />
                    <FAQEntry question={this.props.returnLocalizedString("m0418")} answer={this.props.returnLocalizedString("m0419")} />
                    <FAQEntry question={this.props.returnLocalizedString("m0420")} answer={this.props.returnLocalizedString("m0421")} />

                </section>
            </React.Fragment>
        )
    }
}
const FAQLocalized = localize(FAQ)

class Tutorials extends Component {
    render() {

        return (
            <React.Fragment>


                {['dealer', 'dealergroup'].includes(this.props.orgType) && (

                    <React.Fragment>
                        <h2>{this.props.returnLocalizedString("m0422")}</h2>
                        <Video url="https://www.youtube.com/embed/3FsPbofRPbQ" />
                    </React.Fragment>

                )}

                {['manufacturer', 'manufacturer.region'].includes(this.props.orgType) && (
                    <React.Fragment>
                        <h2>{this.props.returnLocalizedString("m0422")}</h2>
                        <Video url="https://www.youtube.com/embed/PweOSXRHcqw" />
                    </React.Fragment>
                )}


            </React.Fragment>
        )
    }
}
const TutorialsLocalized = localize(Tutorials)

class Index extends Component {
    render() {

        let supportEmail = '';
        if (this.props.orgType === "dealer") {
            supportEmail = config.dealerConfig.supportEmail;
        } else {
            supportEmail = config.manufacturerConfig.supportEmail;
        }

        return (
            <React.Fragment>
                <p>{this.props.returnLocalizedString("m0423")} <a className="hyperlink" href={`mailto:${supportEmail}`}>{`${supportEmail}`}</a> {this.props.returnLocalizedString("m0424")}</p>

                <CardGrid type="support" />
            </React.Fragment>
        )
    }
}
const IndexLocalized = localize(Index)

class SupportPage extends Component {

    render() {

        const orgType = this.context.state.orgType;

        const tabs = (<Tabs>
            <Tab label={this.props.returnLocalizedString("m0004")} link="/dashboard" ></Tab>
            <Tab label={this.props.returnLocalizedString("m0425")} ></Tab>
        </Tabs>);

        return (
            <React.Fragment>
                <Header title={this.props.returnLocalizedString("m0425")} tabs={tabs} />
                <section className="page-content grid-row pad-it support">
                    <IndexLocalized orgType={orgType} />
                    <FAQLocalized orgType={orgType} />
                    {false && <TutorialsLocalized orgType={orgType} />}

                </section>
            </React.Fragment>

        );
    }
}

export default localize(SupportPage);


SupportPage.contextType = AppContext;


// WEBPACK FOOTER //
// ./src/containers/SupportPage.js